import Vue from "vue";
import VueHead from "vue-head";

import App from "./module/app/App.vue";
import router from "./module/app/router";
import store from "./store";
import "./registerServiceWorker";
import infiniteScroll from "vue-infinite-scroll";

// Initialize the Element UI configuration
import "./module/app/element";

Vue.config.productionTip = false;
Vue.use(VueHead);
Vue.use(infiniteScroll);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
